import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP9BudgetCappedReorder202605: FaireAdPerformancePeriodEntity = {
  token: "perf_p9_budget_capped_reorder_202605",
  type: "adPerformancePeriod",
  scope: "REORDER_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2026-05-01",
  endDate: "2026-05-31",
  impressions: 11665,
  clicks: 215,
  adsSpendDollars: 903,
  budgetDollars: 1000,
  salesDollars: 7432,
  bestEstimateRoas: 8.23,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.9,
  reorderConversions: 27,
  dataAvailableAtDate: "2026-06-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
